<template>
  <v-col v-if="tokens && tokens.length > 0" cols="12">
    <v-card outlined>
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('message.volume_tokens') }}</v-toolbar-title>
      </v-toolbar>

      <v-simple-table style="pointer-events: none">
        <template v-slot:default>
          <thead>
            <tr>
              <th>{{ $t('message.purchased') }}</th>
              <th>{{ $t('message.volume') }}</th>
              <th>{{ $t('message.service') }}</th>
              <th>{{ $t('message.status') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="volumeToken in tokens" :key="volumeToken['@id']">
              <td>
                {{ volumeToken.createdAt | moment('LLL') }}
              </td>
              <td>{{ volumeToken.volume }} GB</td>
              <td>
                {{ servicePeriod.airtimePlan.name }}
              </td>
              <td>
                <v-icon size="16" :color="getVolumeTokenStatusColor(volumeToken.status)">
                  mdi-circle
                </v-icon>
                {{ $t('message.' + volumeToken.status) }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CurrentMonthTokens',

  props: {
    servicePeriod: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters({
      error: 'volumetoken/list/error',
      tokens: 'volumetoken/list/items',
      isLoading: 'volumetoken/list/isLoading'
    })
  },

  mounted() {
    this.getTokens(
      '/connect_volume_tokens?pagination=false&base=false&servicePeriod=' +
        this.servicePeriod['@id'] +
        '&createdAt[after]=' +
        this.$moment()
          .startOf('month')
          .format('YYYY-MM-DD')
    )
  },

  methods: {
    ...mapActions({
      getTokens: 'volumetoken/list/default'
    }),

    getVolumeTokenStatusColor(status) {
      switch (status) {
        case 'active':
          return 'success'
        case 'almost_depleted':
          return 'warning'
        case 'available':
          return 'info'
        case 'depleted':
          return 'red'
        default:
          return 'grey'
      }
    }
  }
}
</script>

<style scoped></style>
